module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "layui-unselect layui-form-checkbox",
    class: {
      'layui-form-checked': _vm.currentValue
    },
    on: {
      "click": _vm.changeCheckd
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('i', {
    staticClass: "layui-icon"
  }, [_vm._v("")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5fbe2d1d!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/YmCheckbox.vue
// module id = 595
// module chunks = 2